/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Navigate } from "react-router-dom";
import authRoles from "../../auth/authRoles";
import Users from "./Users";
import InstanceWrapper from "../../shared-components/layouts/InstanceWrapper";
import UserForm from "./instance/UserForm";


const UsersConfig = {
  routes: [
    {
      path: "users",
      element: <Users />,
    },
    {
      path: "users/:id",
      element: <InstanceWrapper />,
      auth: authRoles.leads,
      children: [
        {
          path: "edit",
          element: <UserForm />,
          auth: authRoles.admin,
        },
        {
          path: "",
          element: <Navigate to='/users' />,
        },
        {
          path: "*",
          element: <Navigate to='/users' />,
        },
      ],
    },
  ],
};

export default UsersConfig;
